var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Instruction Completed")]),_c('p',[_vm._v("Your details have been passed to the conveyance in company, they will contact you over the next few days with the next steps.")])])
}]

export { render, staticRenderFns }